/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesMobileEndpointsContractsScoresPostShotRequestModel { 
    shotId?: number;
    number?: number;
    timestamp?: Date;
    type?: string;
    location?: string;
    latitude?: number;
    longitude?: number;
    altitude?: number;
    distance?: number;
    distanceToPin?: number;
    fixQuality?: number;
    scoreId?: number;
}